import React, { useState, useEffect } from "react";
import { useV2Theme } from "../v2/theme/ThemeProvider";
import { v2cx } from "../v2/theme/tokens";

const CookieNotice = () => {
  const { tokens } = useV2Theme();
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    const noticeDismissed = localStorage.getItem("cookie_notice_dismissed");
    if (!noticeDismissed) {
      setTimeout(() => setShowNotice(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_notice_dismissed", "true");
    setShowNotice(false);
  };

  const handleDismiss = () => {
    localStorage.setItem("cookie_notice_dismissed", "true");
    setShowNotice(false);
  };

  if (!showNotice) return null;

  return (
    <div
      className={v2cx(
        "fixed left-0 right-0 z-50 border-t shadow-lg",
        tokens.surface.cardSoft,
        "rounded-none border-x-0 border-b-0"
      )}
      style={{
        bottom:
          "var(--mobile-chrome-bottom, env(safe-area-inset-bottom, 0px))",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className={v2cx("text-sm", tokens.surface.mutedText)}>
              <strong className="text-slate-900">Cookie Notice:</strong> We use
              essential cookies and local storage to maintain your session and
              provide core functionality. These are necessary for the service to
              work and do not require consent. For more information, please see
              our{" "}
              <a
                href="https://decisionpen.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 underline hover:text-blue-600"
              >
                Privacy Policy
              </a>
              .
            </p>
          </div>
          <div className="flex gap-2 sm:flex-shrink-0">
            <button
              type="button"
              onClick={handleDismiss}
              className={v2cx(tokens.button.secondary, "px-4 py-2")}
            >
              Dismiss
            </button>
            <button
              type="button"
              onClick={handleAccept}
              className={v2cx(tokens.button.primary, "px-4 py-2")}
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieNotice;
